// Shared helper to display human-friendly courier names

const COURIER_MAP = {
  jne: "JNE Express",
  jnt: "J&T Express",
  "j&t": "J&T Express",
  tiki: "Tiki",
  sicepat: "Sicepat Express",
  posindonesia: "Pos Indonesia",
  pos: "Pos Indonesia",
  jnt_cargo: "J&T Cargo",
  "j&t-cargo": "J&T Cargo",
  jtcargo: "J&T Cargo",
  ninja: "Ninja Express",
  lion: "Lion Parcel",
  borzo: "Borzo",
  pcp: "PCP Express",
  jet: "JET Express",
  rex: "REX Express",
  first: "First Logistics",
  ide: "ID Express",
  gojek: "Gojek",
  grab: "Grab Express",
  jdl: "JDL Express",
  lalamove: "Lalamove",
  spx: "SPX (Shopee Express)",
  kgx: "KGXpress",
  sap: "SAP Express",
  jxe: "JX Express",
  rpx: "RPX",
  lex: "Lazada Express",
  indah_cargo: "Indah Cargo",
  dakota: "Dakota Cargo",
  rara: "Rara",
  gtl: "GTL (GoTo Logistics)",
  ant_cargo: "Ant Cargo",
  next_logistik: "Next Logistics",
  laris_cargo: "Laris Cargo",
  anteraja: "AnterAja",
  dash_express: "Dash Express",
  deliveree: "Deliveree",
  paxel: "Paxel",
  wahana: "Wahana",
  sentral: "Sentral Cargo",
  sentralcargo: "Sentral Cargo",
};

export const normalizeCourierDisplay = (courierString) => {
  if (!courierString) return "";

  const codes = courierString
    .split(/[, -]+/)
    .map((c) => c.trim())
    .filter(Boolean);

  const names = codes
    .map((code) => COURIER_MAP[code] || code)
    .filter(Boolean);

  return names.join(", ");
};
